// Rules ordered by the order of the submission children

// TODO: Ponder: Should steps be linked by index of array? This seems fragile
// and will break if the order of the steps were changed. Also how can the
// children know what is its own index?
import _isEmpty from 'lodash/isEmpty';

const isEmpty = (data) => {
  switch (typeof data) {
    case 'number':
    case 'boolean': return false;
    case 'string': return !data;
    case 'object': return _isEmpty(data);
    default: return true;
  }
};

const makeResult = (required, error) => {
  if (!required) return null;
  return {
    required: 1,
    completed: error ? 0 : 1,
    error,
  };
};

const validator = {
  required(key, rules, value) {
    const requiredRule = rules.find(rule => rule.required);

    if (requiredRule) {
      if (!isEmpty(value)) {
        return makeResult(true);
      } else {
        const message = requiredRule.message || `${key} is required`;
        return makeResult(true, message);
      }
    }
    return makeResult();
  },
};


const stepsRules = [
  {
    video_file_url: [],
    video_file_url_alt: [],
  },
  {
    // Basic
    title: [{ required: true }],
    language: [{ required: true }],
    description_long: [{ required: true, message: 'synopsis is required' }],
    // Alternate language
    alt_title: [{ required: false }],
    alt_language: [{ required: false }],
    alt_description_long: [{ required: false }],
    // Other
    year: [
      { required: true },
      {
        validator: (rule, value, callback) => {
          const receivedYear = value.getYear();
          const todayYear = new Date().getYear();
          if (receivedYear > todayYear) {
            callback('Production year shouldn\'t be set in the future');
          } else {
            callback();
          }
        },
        trigger: 'blur',
      },
    ],
    country: [{ required: true }],
    directors: [{ required: false }],
    // Video attributes
    genres: [{ required: true, message: 'please choose or enter the genres of the film' }],
    topics: [{ required: false }],
    meta_tags: [{ required: false }],
  },
  {
    collaborators: [],
  },
  {
    image: [],
    attachment: [],
  },
  {},
  {},
];

const managers = [
  (rules, submission) => {
    const propKeys = Object.keys(rules);
    const hasUpload = propKeys.some(key => !!submission[key]);

    return [
      makeResult(true, hasUpload ? null : 'Video file or url is not updated yet.'),
    ];
  },
  (rules, submission) => {
    const propKeys = Object.keys(rules);
    const result = propKeys.map(key => validator.required(key, rules[key], submission[key]));
    return result;
  },
  (rules, submission) => {
    const hasDirector = !!submission.collaborators.filter(collaborator => collaborator.role === 'director').length;
    return [
      makeResult(true, hasDirector ? null : 'Please add at least 1 director in Collaborator'),
    ];
  },
];

export default {
  rules: stepsRules,
  managers,
};



// WEBPACK FOOTER //
// ./src/components/Submission/rules/index.js